// src/utils/cache.ts

import { openDB } from 'idb';

const DB_NAME = 'cacheDB';
const DB_VERSION = 1; // Version for the database schema
const CACHE_STORE_NAME = 'apiCache';

const dbPromise = openDB(DB_NAME, DB_VERSION, {
  upgrade(db) {
    if (!db.objectStoreNames.contains(CACHE_STORE_NAME)) {
      db.createObjectStore(CACHE_STORE_NAME, { keyPath: 'key' });
    }
  },
});

export async function getCacheFromDB(key: string) {
  const db = await dbPromise;
  return db.get(CACHE_STORE_NAME, key);
}

export async function setCacheToDB(key: string, value: any) {
  const db = await dbPromise;
  const cacheObject = { key, ...value }; // Add the key as a property of the object
  await db.put(CACHE_STORE_NAME, cacheObject); // Don't pass 'key' directly
}

export async function deleteCacheFromDB(key: string) {
  const db = await dbPromise;
  await db.delete(CACHE_STORE_NAME, key);
}

export async function deleteAllCache() {
  const db = await dbPromise;
  const transaction = db.transaction(CACHE_STORE_NAME, 'readwrite');
  const store = transaction.objectStore(CACHE_STORE_NAME);

  // Clear all entries in the object store
  await store.clear();
  await transaction.done;
}